import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Select, Button, Row, Col, notification, DatePicker, InputNumber } from 'antd';
import {  CloseOutlined } from '@ant-design/icons';
import StudentLoader from '../common/student-loader';
import BatchLoader from '../common/batch-loader';
import GroupLoader from '../common/group-loader';
import StreamLoader from '../common/stream-loader';
import ClassDivisionLoader from '../common/class-division-loader';
import ResourceLevel from '../common/resource-level-loader';
import { projectStacks,global_var } from '../../services/cs-lab-config';
import { updateResources } from '../../services/ide-apis';
import { getIdeProjectTypeMetaData,trackEvent } from '../utils/util-functions';
import TinyMCEEditor from '../common/tinymce-editor-loader';
import dayjs from 'dayjs';
import { ReactComponent as PlusIcon } from '../../assets/logos/plusIcon.svg';

const EditAssignment = ({ open, onCancel, onCreate, loading, hideClassFilter, editRecord }) => {
    const [form] = Form.useForm();
    const { Option } = Select;
    const [assignTo, setAssignTo] = useState("");
    const [selectedStudent, setSelectedStudent] = useState([]);
    const [selectedLevel, setSelectedLevel] = useState(null);
    const [selectedBatch, setSelectedBatch] = useState([]);
    const [selectedClassDivision, setSelectedClassDivision] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState([]);
    const [buttonText, setButtonText] = useState("Update");
    const [buttonLoader, setButtonLoader] = useState(false);
    const [questionDescription, setQuestionDescription] = useState(null);
    const [intialQuestionDescription, setInitalQuestionDescription] = useState(null);
    const [selectedDueDate, setSelectedDueDate] = useState("");
    // const [dueDateInitialValue, setDueDateInitialValue] = useState('');
    const [isClassChanged, setIsClassChanged] = useState(false);
    const [isIndividualChanged, setIsIndividualChanged] = useState(false);
    const [isBatchChanged, setIsBatchChanged] = useState(false);
    const [isGroupChanged, setIsGroupChanged] = useState(false);
    const [singleClassDivision, setSingleClassDivision] = useState([]);

    useEffect(() =>{
        if(editRecord && editRecord.dueDate){
            const dueDate = dayjs(new Date(editRecord.dueDate))
            setSelectedDueDate(dueDate.format('YYYY-MM-DD'));

            form.setFieldsValue({
                dueDate: dueDate
            });
        }
    },[editRecord,form])

    const handleCancel = () => {
        // setDueDateInitialValue(null);
        onCancel();
    }
    const disabledDate = (current) => {
        // Disable dates before today
        const today = dayjs().startOf('day');
        return current && dayjs(current).isBefore(today, 'day');
    };


    const handleStreamChange = (value) => {
        setSingleClassDivision(prevState => ({
            ...prevState,
            ...value
          }));
    };

    const addClassDivision = () => {
        if (singleClassDivision.fkClassId && singleClassDivision.fkDivisionId) {
            if (!selectedClassDivision.some(
                item => item.fkClassId === singleClassDivision.fkClassId && item.fkDivisionId === singleClassDivision.fkDivisionId &&
                item.streamId === singleClassDivision.streamId
              )) {
                // Add the singleClassDivision to selectedClassDivisions
                setSelectedClassDivision(prevClassDivisions => [...prevClassDivisions, singleClassDivision]);
              }
        }
    }

    const removeClassDivision = (index) => {
        setIsClassChanged(true);
        setSelectedClassDivision(prevClassDivisions => 
          prevClassDivisions.filter((_, i) => i !== index)
        );
    };

    const handleResourceLevelChange = (value) => {
        setSelectedLevel(value);
    };
    const handleStudentChange = (value) => {
        setIsIndividualChanged(true);
        setSelectedStudent(value);
    };
    const handleEditorChange = (content) => {
        setQuestionDescription(content);
    };

    const handleBatchChange = (value) => {
        setIsBatchChanged(true);
        setSelectedBatch(value);
    };

    const handleClassDivision = (value) => {
        setIsClassChanged(true);
        setSingleClassDivision(value);
    };

    const handleGroupChange = (value) => {
        setIsGroupChanged(true);
        setSelectedGroup(value);
    };

    const handleDatePickerChange = (value, dateString) => {
        setSelectedDueDate(dateString);
    };

    const onFinish = async (values) => {
        trackEvent("edit_lab_assignment_question_button_clicked",{});
        setButtonText("Updating Lab Question...");
        setButtonLoader(true);
        if (
            (!selectedBatch || selectedBatch.length === 0) &&
            (!selectedStudent || selectedStudent.length === 0) &&
            (!selectedClassDivision || selectedClassDivision.length === 0) &&
            (!selectedGroup || selectedGroup.length === 0)
        ) {
            // Handle the case where none of the assignment methods are selected
            notification.error({
                message: 'Error',
                description: 'Choose atleast one class division/student/batch/group to assign.',
            });
            setButtonLoader(false);
            setButtonText("Assign");
            return
            // You can also show a notification or alert to the user
        }
        let elements = [];
        let questionArray = [];
        let studentMappings = [];

        const resourceObj = {
            "companyId": global_var.company_id,
            "fkUserLoginId": global_var.user_login_id,
            "Name": "Lab question",
            "projectType": values.projectType,
            "title": values.questionTitle,
            "subjectId": "5903134e6e5694e0619fc82d",  // Directly set to subject CS lab
            "subjectName": "Computer Science",
            "teacherName": global_var.user_name,
            "totalMark": values.maximumMark,
        }
        if (selectedDueDate) {
            resourceObj.dueDate = selectedDueDate;
        } else if (!selectedDueDate) {
            resourceObj.unsetObj = {
                dueDate: 1
            };
        }
        if (selectedLevel?._id) {
            resourceObj.resourceStudentLevelName = selectedLevel.resourceStudentLevelName;
            resourceObj.resourceStudentLevelColor = selectedLevel.resourceStudentLevelColor;
            resourceObj.fkResourceStudentLevelId = selectedLevel._id;
        }
        // if (values.projectType === 'python') {
        //     resourceObj.subSubjectName = "Python";
        //     resourceObj.subSubjectId = "5c0ef9129b0452781408b30f";
        // }
        // if (values.projectType === 'html_css') {
        //     resourceObj.subSubjectName = "HTML";
        //     resourceObj.subSubjectId = "5c0efaa29b0452781008b30b";
        // }
        // if (values.projectType === 'vc3') {
        //     resourceObj.subSubjectName = "Visual Coding";
        //     resourceObj.subSubjectId = "65953a8aee6426264537307c";
        // }
        // if (values.projectType === 'sql2') {
        //     resourceObj.subSubjectName = "SQL";
        //     resourceObj.subSubjectId = "65953a2aee6426264537307b";
        // }
        questionArray.push({
            "type": "text",
            "question": questionDescription
        })
        elements.push({
            "displayName": "Title",
            "type": "cours-element-title",
            "value": values.questionTitle

        })
        elements.push({
            "displayName": "Lab question",
            "value": {
                "mark": {
                    "totalMark": values.maximumMark
                },
                "type": values.projectType,
                "question": questionArray,
                "ques": questionDescription
            }

        })
        resourceObj.elements = elements;
        values.elements = elements;
        // Trigger the parent component's onCreate function

        if (selectedBatch && selectedBatch.length > 0 && isBatchChanged) {
            studentMappings = [{
                "type": "batches",
                "batches": selectedBatch
            }];
        }

        if (selectedGroup && selectedGroup.length > 0 && isGroupChanged) {
            studentMappings = [{
                "type": "groups",
                "groups": selectedGroup
            }];
        }

        if (selectedStudent && selectedStudent.length > 0 && isIndividualChanged) {
            studentMappings = [{
                "type": "individual-students",
                "individualStudents": selectedStudent
            }];
        }

        if (selectedClassDivision && selectedClassDivision.length > 0 && isClassChanged) {
    
            const studentMappingItem = selectedClassDivision.map(item => ({
                type: "class-division",
                classId: item.fkClassId,
                className: item.fkClassName,
                ...(item.fkDivisionId && item.fkDivisionName ? {
                  divisionId: item.fkDivisionId,
                  divisionName: item.fkDivisionName
                } : {}),
                ...(item.streamId && item.classStreamName ? {
                    streamId: item.streamId,
                    streamName: item.classStreamName
                } : {})
              }));
              studentMappings = studentMappingItem;
        }

        let requestObj = {
            resourceData: resourceObj,
            rmId: global_var.roleMappingId,
            resourceMappingId: editRecord.labQuestionsMappingId,
            resourceId: editRecord._id,
        }

        if (studentMappings && studentMappings.length > 0) {
            requestObj.studentMappings = studentMappings;
          }

        if (selectedGroup && selectedGroup.length > 0) {
            requestObj.groups = selectedGroup;
        }
        const response = await updateResources(requestObj);
        setButtonLoader(false);
        setButtonText("Update");
        if (response.data.statusCode === 200) {
            notification.success({
                message: 'Success',
                description: "Successfully updated lab question",
            });
            values._id = editRecord._id;
            values.labQuestionsMappingId = editRecord.labQuestionsMappingId;
            values.dueDate = resourceObj.dueDate;
            values.maximumMark = values.maximumMark ?? editRecord.totalMark;
            if (selectedLevel?._id) {
                values.fkResourceStudentLevelId = selectedLevel._id;
                values.resourceStudentLevelName = selectedLevel.resourceStudentLevelName;
                values.resourceStudentLevelColor = selectedLevel.resourceStudentLevelColor;
            }
            if(response.data.totalAssignedCount){
                values.totalAssignedCount = response.data.totalAssignedCount;
            }
            if (selectedStudent && selectedStudent.length > 0) {
                values.assignTo = [
                    {
                        "type": "individual-students",
                        "individualStudents": selectedStudent
                    }
                ]
            }
            if (selectedBatch && selectedBatch.length > 0) {
                values.assignTo = [
                    {
                        "type": "batches",
                        "batches": selectedBatch
                    }
                ]
            }
            if (selectedGroup && selectedGroup.length > 0) {
                values.assignTo = [
                    {
                        "type": "groups",
                        "groups": selectedGroup
                    }
                ]
            }
            if (selectedClassDivision && selectedClassDivision.length > 0) {
                values.assignTo = selectedClassDivision.map((item) => {
                    const classDivisionObj = {
                        type: "class-division",
                        classId: item.fkClassId,
                        className: item.fkClassName,
                    };
            
                    if (item.fkDivisionId) {
                        classDivisionObj.divisionId = item.fkDivisionId;
                        classDivisionObj.divisionName = item.fkDivisionName;
                    }

                    if (item.streamId) {
                        classDivisionObj.streamId = item.streamId;
                        classDivisionObj.streamName = item.streamName;
                    }
            
                    return classDivisionObj;
                });
            }

            onCreate(values, 'edit');
            handleCancel();
            setIsClassChanged(false)
            setIsIndividualChanged(false)
            setIsBatchChanged(false)
            setIsGroupChanged(false)

        } else {
            notification.error({
                message: 'Error',
                description: response.data.message,
            });
        }
    }

    const renderAssignToSection = () => {
        switch (assignTo) {
            case 'ClassDivisions':
                return (
                    <>
                        <ClassDivisionLoader onChange={handleClassDivision} classDivision={selectedClassDivision ? selectedClassDivision : null} />
                        <StreamLoader  onChange={handleStreamChange}  classDivision={singleClassDivision ? singleClassDivision : null}/>
                        <Col span={8}>
                            <div style={{ display: 'inline-flex', cursor: 'pointer' }} onClick={addClassDivision}>
                                <PlusIcon style={{marginLeft: '10px', fontWeight: 'large', cursor: 'pointer' }} />
                                <span style={{ marginLeft: '5px', color:'#6a737b' }}>Add</span>
                            </div>
                        </Col>
                        <Col span={24} className="mt-2">
                            <Row>
                                {selectedClassDivision.map((cd, index) => (
                                    <div key={index} style={{ backgroundColor: '#1777ff', display: 'flex', alignItems: 'center', marginBottom: '8px', borderRadius:'5px', paddingRight: '5px', paddingLeft: '5px', fontSize:'x-small', color:'white', width:'max-content', marginRight: '5px' }}>
                                        <span style={{ marginRight: '8px' }}>  {`${cd.fkClassName}${cd.fkDivisionName ? `-${cd.fkDivisionName}` : ''}${cd.classStreamName ? ` - ${cd.classStreamName}` : ''}`}</span>
                                        <CloseOutlined onClick={() => removeClassDivision(index)} style={{ cursor: 'pointer' ,fontSize:'x-small'}} />
                                    </div>
                                ))}
                            </Row>
                        </Col>
                    </>
                );
            case 'Batches':
                return <BatchLoader onChange={handleBatchChange} selectedBatch={selectedBatch ? selectedBatch : null} />;
            case 'IndividualStudents':
                return <StudentLoader onChange={handleStudentChange} students={selectedStudent ? selectedStudent : null} />;
            case 'Groups':
                return <GroupLoader onChange={handleGroupChange} selectedGroup={selectedGroup ? selectedGroup : null} />;    
            default:
                return null;
        }
    };

    useEffect(() => {
        // This code will run when the 'open' prop changes
        if (open && editRecord) {
            if (editRecord.elements) {
                editRecord.elements.map(async (item) => {
                    if (item.value && item.value.question) {
                        await Promise.all(item.value.question.map(async (questionItem) => {
                            if (questionItem.type === "text") {
                                setInitalQuestionDescription(questionItem.question);
                                setQuestionDescription(questionItem.question);
                            }
                        }));
                    }
                });
            }
            if (editRecord && editRecord.assignTo) {
                editRecord.assignTo.forEach((assign) => {
                    if (assign.type === 'individual-students') {
                        setSelectedClassDivision([]);
                        setSelectedBatch([]);
                        setSelectedGroup([]);
                        setSelectedStudent(assign.individualStudents);
                        setAssignTo('IndividualStudents');
                    }
                    // const classDivisionObjects = [];
                    if (assign.type === 'class-division') {
                        setSelectedStudent([]);
                        setSelectedBatch([]);
                        setSelectedGroup([]);

                        const convertedArray = editRecord.assignTo.map((item) => ({
                            fkClassId: item.classId,
                            fkClassName: item.className,
                            fkDivisionId: item.divisionId,
                            fkDivisionName: item.divisionName,
                            streamId: item.streamId,
                            classStreamName: item.streamName
                          }));
                        setAssignTo('ClassDivisions');
                        setSelectedClassDivision(convertedArray);
                    }
                    if (assign.type === 'batches') {
                        setSelectedClassDivision([]);
                        setSelectedStudent([]);
                        setSelectedGroup([]);
                        setSelectedBatch(assign.batches);
                        setAssignTo('Batches');
                    }
                    if (assign.type === 'groups') {
                        setSelectedClassDivision([]);
                        setSelectedStudent([]);
                        setSelectedBatch([]);
                        setSelectedGroup(assign.groups);
                        setAssignTo('Groups');
                    }
                });
            }

            if (editRecord.fkResourceStudentLevelId) {
                setSelectedLevel({
                    "_id": editRecord.fkResourceStudentLevelId,
                    "resourceStudentLevelName": editRecord.resourceStudentLevelName,
                    "resourceStudentLevelColor": editRecord.resourceStudentLevelColor
                })
            }


            form.setFieldsValue({
                questionTitle: editRecord.title,
                projectType: editRecord.projectType,
                maximumMark: editRecord.totalMark
            });

        }
        if (!open) {
                // Reset state variables when the modal is hidden
                setQuestionDescription(null);
                setSelectedStudent([]);
                setSelectedLevel(null);
                setSelectedBatch([]);
                setSelectedGroup([]);
                setSelectedClassDivision([]);
                setAssignTo(null);
                form.resetFields();
                // setDueDateInitialValue(null);
        }
    }, [editRecord, open, form]);
    

    return (
        <Modal
            open={open}
            title="Edit Lab Assignment"
            onCancel={handleCancel}
            style={{ backgroundColor: '#ffffff' }}
            width={'50%'}
            footer={[
                <Button key="cancel" onClick={handleCancel} className='cancel-button'>
                    Cancel
                </Button>,
                <Button className='create-button'
                    style={{color:'#fff',borderColor: "#E96358"}}
                    key="ok"
                    loading={buttonLoader}
                    onClick={() => {
                        form
                            .validateFields()
                            .then((values) => {
                                // Set loading to true when the button is clicked
                                onFinish(values);
                            })
                            .catch((info) => {
                                console.log('Validate Failed:', info);
                            });
                    }}
                >
                    {buttonText}
                </Button>,
            ]}
        >
            <Form form={form} name="form_in_modal" onFinish={onFinish} layout="vertical">
                <Row gutter={12}>
                    <Col span={12}>
                        <Form.Item name="questionTitle" label="Question Title" rules={[{ required: true, message: 'Please enter the Question Title' }]}>
                            <Input maxLength={60}/>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item name="projectType" label="Project Type" rules={[{ required: true, message: 'Please select a project type' }]}>
                            <Select defaultValue="default" style={{ width: '100%' }} disabled>
                                <Option value="default" disabled>
                                    Select a project Type
                                </Option>
                                {Object.values(projectStacks)
                                    .flatMap((items) =>
                                    items
                                        .map((item) => ({
                                        ...item,
                                        metaData: getIdeProjectTypeMetaData(item.projectStackName),
                                        }))
                                        .filter((item) => item.metaData.showLabQuestion)
                                    )
                                    .map((item) => (
                                    <Option key={item.projectStackName} value={item.projectStackName}>
                                        {item.metaData.projectStackDisplayName}
                                    </Option>
                                    ))}
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <Form.Item name="questionDescription" label="Question Description" initialValue={questionDescription}>
                    <TinyMCEEditor 
                        onEditorChange={handleEditorChange}
                        initialValue={intialQuestionDescription}
                        showAttachButton={true}
                    />
                </Form.Item>
                <Row  gutter={[10,10]}>
                    <Col span={8}>
                        <Form.Item name="maximumMark" label="Maximum Marks">
                        {/* <Input type='number' /> */}
                        <InputNumber 
                            placeholder='Enter mark'style={{width:'100%' }}
                            min={0}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter') {
                                    event.preventDefault();
                                }
                            }}
                            onChange={(value) => {
                                if (value < 0) {
                                    form.setFieldsValue({
                                        maximumMark: 0,
                                    });
                                }
                            }}
                        />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name="dueDate" label="Due Date" labelCol={{ className: 'poppins-regular' }}>
                                <DatePicker
                                    onChange={handleDatePickerChange}
                                    format="YYYY-MM-DD"
                                    disabledDate={disabledDate}
                                    style={{width: '100%' }}
                                />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name="studentLevel" label="Student proficiency (Optional)" labelCol={{ className: 'poppins-regular' }}>
                            <ResourceLevel onChange={handleResourceLevelChange} studentLevelName={selectedLevel?.resourceStudentLevelName || null}></ResourceLevel>
                        </Form.Item>
                    </Col>
                </Row>

                <label className='mb-2'>Assigned {assignTo}</label>

                {renderAssignToSection()}

            </Form>
        </Modal>
    );
};

export default EditAssignment;
